import React from 'react'
import { MouseParallaxContainer, MouseParallaxChild } from "react-parallax-mouse";
import TripadvisorLogo from '../../assets/images/tripadvisor-logo.svg';
import UnpackedText from '../../assets/images/unpacked-text.svg';
import sunglassesImage from '../../assets/images/new-glasses-image.png';
import adaptorImage from '../../assets/images/power-adaptor-min.png';
import "./heroSection.css"



const HeroSection = () => {
  return (
    <>

<MouseParallaxContainer>
<div className="uk-section-default uk-section uk-flex uk-flex-middle" uk-height-viewport="offset-top: true;" >
  <div className="uk-width-1-1">
      <div className="uk-container">                
        <div className="uk-grid-margin uk-container uk-container-small">
          <div className="tm-grid-expand uk-child-width-1-1 uk-grid uk-grid-stack" uk-grid="">
              <div className="uk-width-1-1 uk-first-column top-z">

                    
                <div className="uk-margin uk-animation-slide-top-medium">
                <img src={TripadvisorLogo} alt='Trip Unpacked Logo' className='' loading='eager' style={{width:"60%"}}/>
                </div>

                <div className="uk-margin-top uk-animation-slide-bottom-medium">
                <img src={UnpackedText} alt='Unpacked' className='' loading='eager' /> 
                </div>

                <div className='margin-top-80 uk-flex uk-flex-center uk-animation-fade'>
                  <div className='scroll'> 
                        <span className='scroll-dot'>  </span> 
                  </div> 
                </div>


              </div>
          </div>

          <div className=" tm-grid-expand uk-margin-xlarge uk-grid" uk-grid="" >
                  <div className="uk-grid-item-match uk-width-1-2@m  uk-first-column">
                      <div className="uk-panel uk-width-1-1">            
                                    
                          <div className="uk-position-absolute uk-width-1-1 uk-scrollspy-inview power-adaptor-container">
                          <MouseParallaxChild factorX={0.05} factorY={0.05}>
                          <img src={adaptorImage} alt='Trip Unpacked' className='uk-border-circle uk-animation-slide-right-medium power-adaptor' loading='eager' />
                          </MouseParallaxChild>
                              
                          </div>

                          <div className="uk-position-absolute uk-width-1-1 uk-scrollspy-inview green-glasses-container">
                          <MouseParallaxChild factorX={-0.07} factorY={-0.05}>
                               <img src={sunglassesImage} alt='Trip Unpacked' className='uk-border-circle uk-animation-slide-left-medium green-glasses' loading='eager' />
                          </MouseParallaxChild>
                          </div>

                          </div>
                          </div>
                          </div>

        
        </div>
    </div>           
  </div>
</div>
</MouseParallaxContainer>
    </>
  )
}

export default HeroSection